// app/plugins/cleanup-sw.client.ts
export default defineNuxtPlugin(() => {
  if (import.meta.client && "serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => {
        for (const registration of registrations) {
          registration.unregister()
            .then((success) => {
              if (success) {
                console.log("[SW Cleanup] Successfully unregistered stale service worker:", registration.scope);
              }
            })
            .catch((error) => {
              console.error("[SW Cleanup] Failed to unregister service worker:", error);
            });
        }
      })
      .catch((error) => {
        console.error("[SW Cleanup] Error listing service workers:", error);
      });
  }
});
